// "GPS":"114.30,30.55"
export default {
    cptDataForm: {
        dataText: '{"value":"湖北省武汉市"}',
        dataSource: 1,
        pollTime: 0,
        apiUrl: '/text',
        sql: 'select id from test limit 1'
    },
    attribute: {
        cptTableData: [{ "name": "值", "value": "", "namekey": "value" }],
        zoom:12,
        centerx:114.300663,
        centery:30.601575,
        showGPS: true,
        textColor: '#fff',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontFamily: '微软雅黑',
        fontSize: 12,
        url: '',
        width: 20,
        height: 20,
        fit: 'fill',
        autoRotate: false,
        rotateDuration: 2,
        imgBgColor: 'rgba(0,0,0,0)',
    },
}

